"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParentMenuPanel = exports.NavItems = exports.LogoWrapper = exports.FlyoutPanelBkg = exports.FlyoutMenuWrap = exports.CmsNav = exports.Close = void 0;
exports.PrimaryNavTray = PrimaryNavTray;
exports.globals = exports.Stopper = exports.ProductFlyoutBtn = exports.PrimaryNavTrayContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _logo = _interopRequireDefault(require("../logo.js"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _primaryNavTrayMenuItem = require("./primary-nav-tray-menu-item");
var _primaryNavTrayMenuItem2 = require("./prodigy/primary-nav-tray-menu-item");
var _navItem = require("./nav-item");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */
/* eslint-disable complexity */

const globals = exports.globals = "pl-g1rjcwya";
const PrimaryNavTrayContainer = exports.PrimaryNavTrayContainer = /*#__PURE__*/(0, _react2.styled)("nav")({
  name: "PrimaryNavTrayContainer",
  class: "pl-pqzxpf0",
  vars: {
    "pqzxpf0-2": [({
      isWrap
    }) => isWrap ? -1 : 1],
    "pqzxpf0-4": [({
      isWrap
    }) => isWrap ? 'block' : 'none'],
    "pqzxpf0-6": [({
      isWrap
    }) => isWrap ? 'flex' : 'none']
  }
});
const ProductFlyoutBtn = exports.ProductFlyoutBtn = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "ProductFlyoutBtn",
  class: "pl-p1td6cxw"
});
const StyledHamburgerIcon = /*#__PURE__*/(0, _react2.styled)(_patternLibraryUtils.Icon)({
  name: "StyledHamburgerIcon",
  class: "pl-suvuevq"
});
const FlyoutPanelBkg = exports.FlyoutPanelBkg = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FlyoutPanelBkg",
  class: "pl-f10baois",
  vars: {
    "f10baois-0": [({
      isParentOpen
    }) => isParentOpen ? 1 : 0],
    "f10baois-1": [({
      isParentOpen
    }) => isParentOpen ? 'visible' : 'hidden']
  }
});
const FlyoutMenuWrap = exports.FlyoutMenuWrap = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FlyoutMenuWrap",
  class: "pl-f1aylcmx",
  vars: {
    "f1aylcmx-0": [({
      isReady
    }) => isReady ? 'visible' : 'hidden'],
    "f1aylcmx-1": [({
      isParentOpen
    }) => isParentOpen ? 'translateX(0)' : 'translateX(-100%)'],
    "f1aylcmx-3": [({
      isParentOpen
    }) => isParentOpen ? '1' : '0'],
    "f1aylcmx-4": [({
      isParentOpen
    }) => isParentOpen ? 'translateX(0)' : 'translateX(100%)']
  }
});
const CmsNav = exports.CmsNav = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "CmsNav",
  class: "pl-c1p3h013",
  vars: {
    "c1p3h013-4": [({
      isReady
    }) => isReady ? 'flex' : 'none']
  }
});
const Close = exports.Close = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Close",
  class: "pl-c19p4i6x",
  vars: {
    "c19p4i6x-0": [({
      isParentOpen
    }) => isParentOpen ? 'visible' : 'hidden'],
    "c19p4i6x-1": [({
      isParentOpen
    }) => isParentOpen ? '1' : '0'],
    "c19p4i6x-3": [({
      isPanelOpen
    }) => isPanelOpen ? 'calc(100% - 44rem)' : 'calc(100% - 22rem)']
  }
});
const ParentMenuPanel = exports.ParentMenuPanel = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ParentMenuPanel",
  class: "pl-ptfv6gx",
  vars: {
    "ptfv6gx-3": [({
      isPanelOpen
    }) => !isPanelOpen ? 'auto' : 'unset']
  }
});
const LogoWrapper = exports.LogoWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LogoWrapper",
  class: "pl-l1636dy5"
});
const NavItems = exports.NavItems = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NavItems",
  class: "pl-n1elaqgr",
  vars: {
    "n1elaqgr-0": [({
      isParentOpen
    }) => isParentOpen ? 'visibile' : 'hidden']
  }
});
const Stopper = exports.Stopper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Stopper",
  class: "pl-sfo2tvr"
});

/**
 * Primary Nav Tray component.
 * @memberof module:PrimaryNav
 *
 * @param {Object} props React props
 * @param {Object[]} props.primaryNavMenu Primary Nav Tray Menu including list and features
 * @param {Object} props.navItems Primary Nav Tray Menu including list and features
 * @param {string} props.closeAriaLabel Aria Label for close button
 * @param {string} props.hamburgerAriaLabel Aria Label for open button
 * @param {string} props.navigationAriaLabel Aria Label for navigation wrapper
 * @param {function} [props.onParentToggle] Callback when nav open state changes
 * @returns {React.ReactElement} Primary Nav Tray
 * @public
 */
function PrimaryNavTray({
  id,
  primaryNavMenu,
  navItems,
  closeAriaLabel = 'close-button',
  hamburgerAriaLabel = 'Open Menu',
  navigationAriaLabel = 'Navigation',
  onParentToggle,
  invert,
  logo
}) {
  const initialState = new Array(primaryNavMenu.menuItems.length).fill(false);
  const [isPanelOpen, setIsPanelOpen] = (0, _react.useState)(initialState);
  const [isParentOpen, setIsParentOpen] = (0, _react.useState)(false);
  const [isReady, setIsReady] = (0, _react.useState)(false);
  const [isLazyLoaded, setIsLazyLoaded] = (0, _react.useState)(false);
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  const {
    isMobile
  } = (0, _patternLibraryUtils.useDeviceDetect)();
  const primaryNavTray = (0, _react.useRef)();
  const cmsNav = (0, _react.useRef)();
  const hamburgerButton = (0, _react.useRef)();
  const [wrap, setWrap] = (0, _react.useState)(true);
  const [htmlElement, setHtmlElement] = (0, _react.useState)(null);
  const PrimaryNavTrayMenuItem = primaryNavMenu?.isProdigy ? _primaryNavTrayMenuItem2.PrimaryNavTrayMenuItem : _primaryNavTrayMenuItem.PrimaryNavTrayMenuItem;
  const isDesktop = width >= _patternLibraryUtils.size.mostCommon;
  function setParentOpen(value) {
    setIsParentOpen(value);
    value ? htmlElement?.classList.add('nav-flyout-open') : htmlElement?.classList.remove('nav-flyout-open');
    if (onParentToggle) onParentToggle(value);
  }
  const handleClick = ({
    target
  }) => {
    if (primaryNavTray?.current.contains(target)) {
      return;
    }
    setIsPanelOpen(initialState);
    setParentOpen(false);
  };
  const handleEscape = ({
    code
  }) => {
    if (code === 'Escape') {
      setParentOpen(false);
      setIsPanelOpen(initialState);
      hamburgerButton.current.focus();
    }
  };

  /*
   * Handler for breaking down primary nav
   * to hamburger menu if items were to wrap
   */
  function handleResize() {
    // Greater than mostCommon viewport the non-hamburger styling will always display
    if (width >= _patternLibraryUtils.size.mostCommon) {
      setWrap(false);
      return;
    }

    // Less than laptop viewport the hamburger styling will always display
    if (width < _patternLibraryUtils.size.laptop) {
      setWrap(true);
      return;
    }

    /*
     * Between mostCommon and laptop viewports determine if items would wrap:
     *   If wrapped, hamburger styling will display
     *   If not wrapped, non-hamburger styling will display
     */
    if (cmsNav.current && width > _patternLibraryUtils.size.laptop) {
      const items = Array.from(cmsNav.current.children);
      const basis = items[0].getBoundingClientRect().top;
      items?.map(child => child.getBoundingClientRect().top !== basis && setWrap(true));
    }
  }
  function loadNavImages() {
    if (!isLazyLoaded) {
      const images = primaryNavTray.current.querySelectorAll('img[data-src]');
      for (const image of images) {
        image.setAttribute('src', image.getAttribute('data-src'));
      }
      setIsLazyLoaded(true);
    }
  }

  // Prevent nav tray from showing switch between desktop and hamburger
  let resizeTimeout;
  let timeout;
  (0, _react.useEffect)(() => {
    window.clearTimeout(resizeTimeout);
    if (!isMobile) {
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }
      timeout = window.requestAnimationFrame(handleResize);
    }
    resizeTimeout = window.setTimeout(() => setIsReady(true), 400);
    return () => setIsReady(false);
  }, [isMobile, width]);
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('mousedown', handleClick);
      document.addEventListener('keydown', handleEscape);
      return () => {
        document.removeEventListener('mousedown', handleClick);
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [htmlElement]);
  (0, _react.useEffect)(() => {
    setHtmlElement(document.querySelector('html'));
  }, []);
  (0, _react.useEffect)(() => {
    isMobile && handleResize();
  }, []);
  const handleCloseAllClick = () => {
    setParentOpen(false);
    setIsPanelOpen(initialState);
  };
  const handleCloseAllEnter = event => {
    event.key === 'Enter' && handleCloseAllClick();
  };
  return /*#__PURE__*/_react.default.createElement(PrimaryNavTrayContainer, (0, _extends2.default)({
    id: `id-${id}`,
    ref: primaryNavTray,
    "aria-label": navigationAriaLabel,
    "aria-expanded": "false",
    "data-cy": "primary-nav-tray",
    onClick: loadNavImages,
    isReady: isReady
  }, wrap && {
    'data-wrap': true
  }, {
    isWrap: wrap
  }), /*#__PURE__*/_react.default.createElement(ProductFlyoutBtn, {
    "aria-label": hamburgerAriaLabel,
    onClick: () => setParentOpen(!isParentOpen),
    ref: hamburgerButton,
    "data-cy": "hamburger-button"
  }, /*#__PURE__*/_react.default.createElement(StyledHamburgerIcon, {
    name: "hamburger",
    width: 30,
    height: 30,
    fill: _intents.default.ux.box.foregroundColor
  })), /*#__PURE__*/_react.default.createElement(FlyoutPanelBkg, {
    isParentOpen: isParentOpen,
    role: "presentation",
    onClick: handleCloseAllClick
  }), /*#__PURE__*/_react.default.createElement(FlyoutMenuWrap, {
    isReady: isReady,
    isParentOpen: isParentOpen,
    isPanelOpen: isPanelOpen.includes(true)
  }, /*#__PURE__*/_react.default.createElement(ParentMenuPanel, {
    "data-partial": !isDesktop ? 'light1' : '',
    "data-cy": "tray-panel",
    isPanelOpen: isPanelOpen.includes(true)
  }, /*#__PURE__*/_react.default.createElement(LogoWrapper, {
    "data-cy": "tray-logo",
    onClick: handleCloseAllClick
  }, /*#__PURE__*/_react.default.createElement(_logo.default, (0, _extends2.default)({
    collapsedLogo: true
  }, logo))), /*#__PURE__*/_react.default.createElement(CmsNav, {
    "aria-hidden": "true",
    ref: cmsNav,
    isReady: isReady,
    isParentOpen: isParentOpen,
    "data-expanded": isParentOpen
  }, primaryNavMenu?.menuItems?.map(({
    title: text,
    href,
    primaryNavTray: tray,
    _name
  }, i) => /*#__PURE__*/_react.default.createElement(PrimaryNavTrayMenuItem, {
    key: i,
    index: i,
    isOpen: isPanelOpen[i],
    isParentOpen: isParentOpen,
    isWrap: wrap,
    invert: invert,
    setIsOpen: setIsPanelOpen,
    setIsParentOpen: setParentOpen,
    text: text,
    href: href,
    primaryNavTray: tray,
    _name: _name
  }))), /*#__PURE__*/_react.default.createElement(NavItems, {
    "data-cy": "tray-nav-items",
    isParentOpen: isParentOpen
  }, navItems?.menuItems?.map(({
    title,
    href,
    icon,
    _name
  }, i) => /*#__PURE__*/_react.default.createElement(_navItem.PrimaryNavTrayNavItem, {
    key: i,
    text: title,
    href: href,
    icon: icon,
    _name: _name
  })))), /*#__PURE__*/_react.default.createElement(Close, {
    tabIndex: "0",
    className: "close",
    "aria-label": closeAriaLabel,
    onClick: handleCloseAllClick,
    onKeyPress: handleCloseAllEnter,
    isParentOpen: isParentOpen,
    isPanelOpen: isPanelOpen.includes(true)
  })), /*#__PURE__*/_react.default.createElement(Stopper, {
    tabIndex: "0",
    onFocus: handleCloseAllClick
  }));
}
PrimaryNavTray.propTypes = {
  id: _propTypes.default.string,
  primaryNavMenu: _propTypes.default.shape({
    isProdigy: _propTypes.default.bool,
    menuTitle: _propTypes.default.string,
    menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      primaryNavTray: _propTypes.default.shape({
        primaryNavMenus: _propTypes.default.arrayOf(_propTypes.default.shape({
          menuItems: _propTypes.default.arrayOf(_propTypes.default.shape({
            title: _propTypes.default.string
          })),
          menuTitle: _propTypes.default.string
        }))
      }),
      title: _propTypes.default.string
    })),
    id: _propTypes.default.string
  }),
  navItems: _propTypes.default.object,
  closeAriaLabel: _propTypes.default.string,
  hamburgerAriaLabel: _propTypes.default.string,
  navigationAriaLabel: _propTypes.default.string,
  onParentToggle: _propTypes.default.func,
  invert: _propTypes.default.bool,
  isSticky: _propTypes.default.bool,
  logo: _propTypes.default.shape({
    mobileImage: _propTypes.default.shape({
      height: _propTypes.default.number,
      width: _propTypes.default.number,
      altText: _propTypes.default.string,
      url: _propTypes.default.string
    }),
    desktopImage: _propTypes.default.shape({
      height: _propTypes.default.number,
      width: _propTypes.default.number,
      altText: _propTypes.default.string,
      url: _propTypes.default.string
    })
  })
};